import React, { useEffect } from 'react';

const APP_STORE_URL =
  'https://apps.apple.com/us/app/morph-inspect/id6737966284?utm_source=qr_code&utm_medium=landing_page&utm_campaign=download';
const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.morph_technologies.inspectionapp&utm_source=qr_code&utm_medium=landing_page&utm_campaign=download';
const WEB_DOWNLOAD_URL =
  'https://www.morph-technologies.com/#download?utm_source=qr_code&utm_medium=landing_page&utm_campaign=download';

declare global {
  interface Window {
    gtag: (
      command: string,
      targetId: string,
      config?: Record<string, unknown>,
    ) => void;
    opera?: string;
  }
}

const QRDownload = () => {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera || '';
    let target = WEB_DOWNLOAD_URL; // Default to web for desktop
    let platform = 'desktop';

    // Track the visit
    if (window.gtag) {
      window.gtag('event', 'qr_download_visit', {
        user_agent: ua,
        referrer: document.referrer,
      });
    }

    if (/android/i.test(ua)) {
      target = GOOGLE_PLAY_URL;
      platform = 'android';
    } else if (/iPad|iPhone|iPod/.test(ua)) {
      target = APP_STORE_URL;
      platform = 'ios';
    }

    // Track the redirect
    if (window.gtag) {
      window.gtag('event', 'qr_redirect', {
        platform: platform,
        target_url: target,
      });
    }

    window.location.href = target;
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Redirecting to Morph App...</h2>
      <p>
        If you are not redirected, <a href={WEB_DOWNLOAD_URL}>click here</a>.
      </p>
    </div>
  );
};

export default QRDownload;
